<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-6 p-5">
        <div class="mx-auto mb-3">
          <h4 class="d-inline align-middle text-center">
            Fill in personal information to start working with the system
          </h4>
        </div>
        <b-form
          @submit.prevent="inviteUsers"
        >

          <TextField 
            placeholder="Enter Name"
            label="Company Name"
            name="company_name"
            v-model="model.company_name"
            v-if="model.recruitment_type == 'company'"
            :error="$v.model.company_name.$error"
            :errorMessage="$v.model.company_name.errorMessage"
          />

          <TextArea 
            placeholder="Enter Company Details..."
            label="Company details"
            name="company_details"
            v-model="model.company_details"
            v-if="model.recruitment_type == 'company'"
            :error="$v.model.company_details.$error"
            :errorMessage="$v.model.company_details.errorMessage"
          />

          <TextField 
            placeholder="Enter City"
            label="City"
            name="city"
            v-model="model.city"
            v-if="model.recruitment_type == 'company'"
          />

          <TextField 
            placeholder="Enter Country"
            label="Country"
            name="country"
            v-model="model.country"
            v-if="model.recruitment_type == 'company'"
          />

          <TextField 
            placeholder="Enter First Name"
            label="First Name"
            name="first_name"
            v-model="model.first_name"
            v-if="model.recruitment_type != 'company'"
            :error="$v.model.first_name.$error"
            :errorMessage="$v.model.last_name.errorMessage"
          />

          <TextField 
            placeholder="Enter Last Name"
            label="Last Name"
            name="last_name"
            v-model="model.last_name"
            v-if="model.recruitment_type != 'company'"
            :error="$v.model.first_name.$error"
            :errorMessage="$v.model.last_name.errorMessage"
          />

          <div class="form-group">
              <label class="form-label">Email</label>
              <input type="text" 
                readonly="" 
                class="form-control-plaintext"
                v-model="model.email"
              >
          </div>

          <TextField 
            placeholder="Password"
            label="Password *"
            name="password"
            type="password"
            v-model="model.password"
            :error="$v.model.password.$error"
            :errorMessage="passwordError"
          />

          <TextField 
            placeholder="Confirm Password"
            label="Confirm Password *"
            name="confirm"
            type="password"
            v-model="model.confirm_password"
            :error="$v.model.confirm_password.$error"
            :errorMessage="$v.model.confirm_password.errorMessage"
          />


          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-block">
              <i class="uil-check"></i> Submit
            </button>
          </div>

        </b-form>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/default'
import TextField from '@components/form/textfield'
import TextArea from '@components/form/textarea'
/* import InputTag from 'vue-input-tag' */
import { mapActions } from 'vuex'
import  AuthMixin from '@mixins/auth'
import  FormMixin from '@mixins/form'
import { required, sameAs, requiredIf } from 'vuelidate/lib/validators'
  
export default {
  mixins: [AuthMixin, FormMixin],
  data(){
    return {
      model:{
        id:'',
        email:'',
        first_name:'',
        last_name:'',
        password:'',
        confirm_password:''
      },
      passwordError: ''
    }
  },
  components:{Layout, TextField, TextArea},
  methods:{
    ...mapActions('user', ['findByToken', 'step_1']),
    inviteUsers(){

      if (this.validateForm()) {
				this.toggleLoading()
				return;
      }

      this.step_1(this.model).then(res => {
        if(res.data.done){
          this.logout()
        }else if(res.data.ok){
          this.$router.push('/user/step_2?key=' + this.$route.query.key)
        }

      }).catch(() => {
        // Object.keys(err.response.data).forEach(key => {
        //   error += err.response.data[key]
        // })
      })
    }
  },
  mounted() {
    this.findByToken({
      token:this.$route.query.key
    }).then(user => {
      let data = user.data.user
      this.model.email = data.email
      this.model.id = data._id
      this.model.recruitment_type = data.recruitment_type
      this.model.access_type = data.access_type

      if(user.data.step == 1){
        this.$router.push('/user/step_2?key=' + this.$route.query.key)
      }
    }).catch(() => {
      this.$router.push('/')
    })
  },
  validations: {
    model:{
      password: {
        required,
        passwordRule: function(value) {
          let valid = (/[A-Z]/.test(value) && /[a-z]/.test(value) && /[0-9]/.test(value) && /[#?!@$%^&*-]/.test(value) && value.length > 5)

          this.passwordError = (valid ? '' : 'Password must have at least (') + 
          (value.length > 5 ? '' : 'length of 6 characters; ') + 
          (/[A-Z]/.test(value) ? '' : '1 upper case letter; ') + 
          (/[a-z]/.test(value) ? '' : '1 lower case letter; ') + 
          (/[0-9]/.test(value)  ? '' : '1 number; ') + 
          (/[#?!@$%^&*-]/.test(value) ? '' : '1 special character') + 
          (valid ? '' : ')')
          
          return /[A-Z]/.test(value) && /[a-z]/.test(value) && /[0-9]/.test(value) && /[#?!@$%^&*-]/.test(value) && value.length > 5
        }
      },
      confirm_password: {
        sameAsPassword: sameAs('password')
      },
      first_name:{
        required: requiredIf(function(item){
          return item.recruitment_type == 'individual'
        })
      },
      last_name:{
        required: requiredIf(function(item){
          return item.recruitment_type == 'individual'
        })
      },
      company_name:{
        required: requiredIf(function(item){
          return item.recruitment_type == 'company'
        })
      },
      company_details:{
        required: requiredIf(function(item){
          return item.recruitment_type == 'company'
        })
      }
    }
  }
}
</script>